import React, {Component} from 'react';
import { Flex } from 'antd-mobile';
import DateTimePicker from 'date-time-picker';
import parseDateTime from './moment'
import WrapComponent from '../component/WrapComponent';


const style = {
    position: 'absolute',
    marginTop: '75px'
}
class DateTime extends Component{
    constructor(props){
        super(props);
        var date = '',time = '';
        if(props.default_value){
            var defaultValue = parseDateTime(props.default_value, props.date_format)
            date = defaultValue.split(' ')[0]
            time = defaultValue.split(' ')[1]
        }
        this.state = {
            date: date,
            time: time
        }
    }
    onChangeDate = ()=>{
        let readonly = this.props.is_readonly
        if(readonly) return;
        this.date && this.date.destroy();
        this.date = new DateTimePicker.Date({
          lang: window.sLanguageType.includes('zh') ? 'zh-CN' : 'en',
          default: this.state.date
        })
        
        this.date.on('selected', (formatDate, now) => {
            this.setState({
                date: formatDate
            })
            this.updateFieldsValue();
        })
        this.date.on('cleared', () => {
            this.setState({
                date: '',
            })
            this.updateFieldsValue();
        })
    }
    formatDateTime (dateTimeString) {
        let dateTimeArr = dateTimeString.split(' ');
        let dateArr = dateTimeArr[0].split('-');
        let timeArr = dateTimeArr[1].split(':');
        let year = dateArr[0] || '00';
        let month = dateArr[1] || '00';
        let day = dateArr[2] || '00';
        let hours = timeArr[0] || '00';
        let minutes = timeArr[1] || '00';
        let second = timeArr[2] || '00';

        return new Date(year, month - 1, day, hours, minutes, second);
    }
    updateFieldsValue() {
        let defaultValue = '';
        if (this.state.date && this.state.time) {
            defaultValue = this.formatDateTime(this.state.date + ' ' + this.state.time).getTime()
        }
        console.log(defaultValue)
        this.props.form.setFieldsValue({
            [this.props.api_name]: defaultValue
        })
        
    }
    onChangeTime = ()=>{
        let readonly = this.props.is_readonly
        if(readonly) return;
        this.time && this.time.destroy();
        this.time = new DateTimePicker.Time({
          lang: window.sLanguageType.includes('zh') ? 'zh-CN' : 'en',
          default: this.state.time
        })
        
        this.time.on('selected', (formatDate, now) => {
            this.setState({
                time: formatDate
            })
            this.updateFieldsValue();
        })
        this.time.on('cleared', () => {
            this.setState({
                time: ''
            })
            this.updateFieldsValue();
        })
    }
    render(){
        let { api_name, form, is_required,errorText } = this.props;
        let { date, time } = this.state;
        const {getFieldProps} = form;
        let tmpDate = '';
        date && (tmpDate = date.replace(/\//g, '-'));
        let fieldProps = getFieldProps(api_name, {  // eslint-disable-line
            initialValue: (tmpDate && time) ? this.formatDateTime(tmpDate + ' ' + time).getTime() : null,
            validate: [{
                trigger: 'onChange',
                rules:[{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            }]
        });
        return (
            <Flex className="form-date-time-picker">
                <Flex.Item onClick={this.onChangeDate}>
                    <input className='date-time-picker' readOnly value={date} placeholder={$st('选择日期')} />
                </Flex.Item>
                <Flex.Item onClick={this.onChangeTime}>
                    <input className='date-time-picker' readOnly value={time} placeholder={$st('选择时间')} />
                </Flex.Item>
                {(errorText && (!date || !time)) && <div className='input-error' style={style}>{errorText}</div>}
            </Flex>
        )
    }
}

export default WrapComponent(DateTime);


// WEBPACK FOOTER //
// ./src/form/datetime.js